import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = "/user-plan-purchases";

const userPlanPurchaseApi = {
  getUserPlanPurchases(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getUserPlanPurchase(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },

  getSummary(params: any): Promise<any> {
    const url = `${path}/summary`;
    return api.get(url, params);
  },

  putUserPlanPurchase(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  putBannerInfo(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}/banner-image`;
    return api.put(url, dataForm);
  },

  deletePaymentHistory(id: string | number): Promise<any> {
    const url = `${path}/${id}`;
    return api.delete(url)
  },
};

export default userPlanPurchaseApi;
